export default {
  index: 'partner-staff-list-view',
  store: 'partner-staff-create-view',
  edit: 'partner-staff-edit-view',
};
